import { useState, useEffect } from "react"
import { useLocalization } from "@tm/localization"
import { channel, SearchFilters } from "@tm/models"
import { encodeUniqueId, renderRoute, TmaHelper, uniqueId } from "@tm/utils"
import { useHistory, useParams } from "react-router"
import { useWorkTask } from "@tm/context-distribution"
import { getBundleParams } from "../../../utils"
import { IActions } from "../../direct-search-widget/business"
import { DirectSearchField } from "../DirectSearchField/DirectSearchField"

type Props = {
    directSearchRoute: string
    queryHistory: Array<string>
    showHints?: boolean
    actions?: IActions
}

export default function DirectSearchWidgetContent({ directSearchRoute, actions }: Props) {
    const { translateText } = useLocalization()
    const matchParams = useParams<{ workTaskId?: string }>()
    const history = useHistory()
    const { workTaskId } = useWorkTask()
    const [currentShortcutKey, setCurrentShortcutKey] = useState("")
    const [query, setQuery] = useState("")
    const [selectedSearchFilter, setSelectedSearchFilter] = useState(SearchFilters.All)
    // showQueryHistory for landingpage view of History. Set in Parts BundleParams in the UI-Config
    const { minimumSearchLength } = getBundleParams()

    useEffect(() => {
        actions?.loadQueryHistory()
        return channel("APP").subscribe("SHORTCUTS", (rez) => {
            if (rez.key === "DIRECT") {
                setCurrentShortcutKey(rez.key + Math.random())
            }
        })
    }, [])

    let params = matchParams
    if (!params.workTaskId) {
        params = { ...params, workTaskId: encodeUniqueId(uniqueId()) }
    }

    function handleDirectSearch(searchQuery: string, searchFilter: SearchFilters) {
        const url = renderRoute(directSearchRoute, params)
        TmaHelper.Shared.ByArticleAndUniParts.SetSearchContext("directSearch", searchQuery, params.workTaskId || workTaskId, true)
        history.push(`${url}?query=${encodeURIComponent(searchQuery)}&searchFilter=${searchFilter}`)
    }

    return (
        <DirectSearchField
            key={currentShortcutKey}
            placeholder={translateText(138)}
            fullWidth
            minimumSearchLength={minimumSearchLength.directSearch}
            onStartSearch={() => handleDirectSearch(query, selectedSearchFilter)}
            onChange={(value) => setQuery(value)}
            value={query}
            onSearchFiltersChanged={(searchFilter) => {
                setSelectedSearchFilter(searchFilter)
            }}
            onStartSearchWithQuery={(newQuery: string, searchFilter: SearchFilters) => {
                handleDirectSearch(newQuery, searchFilter)
            }}
        />
    )
}
